import React, { useCallback } from 'react';
import styled from 'styled-components';
import { invokeLater } from '../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { CommandRegistry } from '../../concepts/commands/CommandRegistry';
import { GoItem, GoPalette, GoResult } from '../../ui';
import { Fill } from '../../ui/Fill';
import { useResolve } from '../Container';
import { EditorSession, useEditorSessionObserver } from './EditorSession';
import { StatePropertyRef } from './ExtendableStore';
import { MyRoleInfo } from './MyRoleInfo';
import { IsElevated } from './workflow/IsElevated';

export const IsEditorPaletteOpen = StatePropertyRef<boolean>('isEditorPaletteOpen');

const Frame = styled(Fill)`
    z-index: 1;
    pointer-events: none;
    & > * {
        pointer-events: all;
    }
`;

export const EditorPalette = React.memo(() => {

    const commands = useResolve(CommandRegistry);
    const dispatch = useResolve(CommandDispatcher);
    const session = useResolve(EditorSession);

    const open = useEditorSessionObserver(IsEditorPaletteOpen);
    const { canParticipate } = useEditorSessionObserver(MyRoleInfo);
    const elevated = useEditorSessionObserver(IsElevated);

    const provider = useCallback((input: string) => commands.suggest(input, true) as GoItem[], [commands]);

    const onResult = useCallback((result: GoResult) => {
        if (result.success) {
            dispatch(result.item as any, result.params);
        }
        session.update(IsEditorPaletteOpen, false);
        // 1337 Hack St. Hackford, Hack City, HA3 7ER
        invokeLater(() => {
            document.getElementById('tool-layer').focus();
        });
    }, []);

    return <Frame>
        {open && canParticipate && elevated && <GoPalette provider={provider} callback={onResult} />}
    </Frame>;
});

// const useSpotlightTriggerFromSessionState = () => {
//     const open = useEditorSessionObserver(IsEditorPaletteOpen);
//     useEffect(() => {
//         if (open) {
//             spotlight.open();
//         }
//         else {
//             spotlight.close();
//         }
//     }, [open]);
// };

// const createSearchables = (label: string) => {
//     if (!label) return {};
//     const words = label.split(' ');
//     const search = words.map(x => x.replace(/[^a-zA-Z]/g, '')).join(' ');
//     const hcraes = words.reverse().map(x => x.replace(/[^a-zA-Z]/g, '')).join(' ');
//     return { search, hcraes };
// };

// function useFilterableCommands() {
//     const [query, setQuery] = React.useState('');
//     const commands = useResolve(CommandRegistry);

//     const allCommands = useMemo(() => Array.from(commands), [commands]);

//     const filteredCommands = React.useMemo(() => {
//         return fuzzySearch({
//             items: allCommands.map(x => ({
//                 ...x,
//                 ...createSearchables(x.label),
//             })),
//             keys: ['search', 'hcraes'],
//             search: query.trim(), // also filter query
//         });
//     }, [allCommands, query]);

//     return {
//         filteredCommands,
//         query,
//         setQuery,
//     };
// }

// interface CommandMountProps {
//     cd: CommandDefinition;
//     onAction: (action: 'complete' | 'cancel') => void;
// }

// const CommandMount = React.memo((props: CommandMountProps) => {
//     const { cd, onAction } = props;
//     const Flow = cd.ui?.flow || (() => null);
//     return <Flow onAction={onAction} />;
// });

// export const EditorPalette = React.memo(() => {

//     const [selected, setSelected] = React.useState<CommandDefinition | null>(null);
//     const onSelect = useCallback((cd: CommandDefinition) => {
//         if (cd.ui?.flow) {
//             setSelected(cd);
//         }
//     }, []);

//     useSpotlightTriggerFromSessionState();
//     const { filteredCommands, query, setQuery } = useFilterableCommands();

//     const onReset = useCallback(() => {
//         setQuery('');
//         setSelected(null);
//     }, []);

//     useKey('Escape', (e) => {
//         e.preventDefault();
//         if (selected) {
//             setSelected(null);
//         }
//     });

//     return (
//         <Spotlight.Root
//             query={query}
//             onQueryChange={setQuery}
//             closeOnEscape={!selected}
//             closeOnActionTrigger={false}
//             onSpotlightOpen={onReset}>
//             {!selected && <>
//                 <Spotlight.Search placeholder="Search..." />
//                 <Spotlight.ActionsList>
//                     {filteredCommands.length > 0 ? (
//                         <FixedScroller maxHeight={30}>
//                             {filteredCommands.map(x =>
//                                 <Spotlight.Action
//                                     key={x.name}
//                                     highlightQuery
//                                     label={x.label}
//                                     description={'No description available.'}
//                                     onClick={() => onSelect(x)}
//                                 />
//                             )}
//                         </FixedScroller>
//                     ) : (
//                         <Spotlight.Empty>Nothing found...</Spotlight.Empty>
//                     )}
//                 </Spotlight.ActionsList>
//             </>}
//             {selected && <Flexer padding="1">
//                 <CommandMount cd={selected} onAction={() => setSelected(null)} />
//             </Flexer>}
//         </Spotlight.Root>
//     );
// });
